
import './App.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Routes, Route } from "react-router-dom";
import Home from "./components/pages/Home/Home";
// import Header from "./components/common/Header/New";
import Header from "./components/common/Header/Header";
import Footer from "./components/common/Footer/Footer";
import Dashboard from "./components/pages/Dashboard/Dashboard";
import Login from "./components/pages/Login/Login";
import Register from "./components/pages/Register/Register";
import NotFound from './components/pages/NotFound/NotFound';
import ProductDescription from './components/pages/Product/ProductDescription';
import Cart from './components/pages/Cart/Cart';
import Order from './components/pages/Order/Order';
import Profile from './components/pages/Profile/Profile';
import EditProfile from './components/pages/Profile/EditProfile';
import ChangePassword from './components/pages/Profile/ChangePassword';
import ForgotPassword from './components/pages/Login/ForgotPassword';
import ResetPassword from './components/pages/Login/ResetPassword';
import AddProduct from './components/pages/Product/AddProduct';
import VerifyEmail from './components/pages/Profile/VerifyEmail';
import AdminDashboard from './components/pages/AdminDashboard/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import Unauthorized from './components/pages/Unauthorized/Unauthorized';
import Checkout from "./components/pages/Checkout/Checkout";
import Products from './components/pages/Product/Products';
import Women from './components/pages/Women/Women';
import Men from './components/pages/Men/Men';
import Kids from './components/pages/Kids/Kids';
import Toys from './components/pages/Toys/Toys';
import Beauty from './components/pages/Beauty/Beauty';
import Jewellery from './components/pages/Jewellery/Jewellery';
import UserLocation from './components/pages/UserLocation/UserLocation';
import Admin from './components/pages/Admin/Admin';
import ProductDetails from './components/pages/Product/ProductDetails';
import Policy from './components/pages/Policy/Policy';
import Address from './components/pages/Address/Address';
import BestSeller from './components/pages/BestSeller/BestSeller';
import Category from './components/pages/Category/Category';
import ProductSearch from './components/pages/Product/ProductSearch';
const App = () => {
  return (
    <Container fluid>
      <ToastContainer />
      <Row>
        <Col md={12} className="p-0">
          <Header />
        </Col>
      </Row>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route path="/products" element={<Products />} />
        <Route path="/product/:id" element={<ProductDescription />} />
        <Route path="/p/category/:category" element={<Category />} />

        <Route path="/jewellery" element={<Jewellery />} />
        <Route path="/women" element={<Women />} />
        <Route path="/men" element={<Men />} />
        <Route path="/kids" element={<Kids />} />
        <Route path="/toys" element={<Toys />} />
        <Route path="/beauty" element={<Beauty />} />
        <Route path="/best-seller" element={<BestSeller />} />

        <Route path="/cart" element={<Cart />} />
        <Route path="/address" element={<Address />} />
        <Route path="/my/order" element={<Order />} />
        <Route path="/my/profile" element={<Profile />} />
        <Route path="/my/profile/edit" element={<EditProfile />} />
        <Route path="/my/change-password" element={<ChangePassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/admin/add-product" element={<AddProduct />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/checkout" element={<Checkout />} />
        {/* <Route path="/product/:description" element={<ProductDescription />} /> */}
        <Route path="/product/slug/:slug" element={<ProductDetails />} />
        <Route path="/search" element={<ProductSearch />} />

        <Route path="/user-location" element={<UserLocation />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/policy" element={<Policy />} />


        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={<ProtectedRoute element={<Dashboard />} allowedRoles={["user", "admin"]} />}
        />
        <Route
          path="/admin-dashboard"
          element={<ProtectedRoute element={<AdminDashboard />} allowedRoles={["admin"]} />}
        />

      </Routes>
      <Row>
        <Col md={12}>
          <Footer />
        </Col>
      </Row>

    </Container>
  );
};

export default App;
